import { render } from "./NewsNYShow.vue?vue&type=template&id=72169e6e&scoped=true"
const script = {}

import "./NewsNYShow.vue?vue&type=style&index=0&id=72169e6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72169e6e"]])

export default __exports__